var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppLayout',{attrs:{"enable-background":false,"enable-footer":false}},[_c('MobileSignup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }